export const auth = {
  loginTitle: 'Entrar',
  loginSubtitle: 'Acesse o NT Academy com sua conta corporativa.',
  tagline: 'A plataforma de aprendizado da NTConsult.',
  signInWithMicrosoft: 'Entrar com Microsoft',
  useCorporateAccount: 'Use sua conta corporativa NT.',
  errorAuthFailedTitle: 'Não foi possível entrar.',
  errorAuthFailedDescription: 'Tente novamente. Se persistir, contate o suporte de TI.',
  errorAccountInactiveTitle: 'Sua conta está inativa.',
  errorAccountInactiveDescription:
    'Procure o RH ou o administrador do NT Academy para reativar o acesso.',
  callbackPending: 'Concluindo o login...',
  logout: 'Sair',
  logoutConfirmTitle: 'Sair da sua conta?',
  logoutConfirmDescription: 'Você precisará entrar de novo para continuar.',
  profile: {
    title: 'Meu perfil',
    identity: 'Identidade',
    roles: 'Perfis',
    rolesHint: 'Perfis são concedidos pelo administrador.',
    adminBadge: 'Admin',
    shortcuts: 'Atalhos',
    myCertificates: 'Meus certificados',
  },
} as const;
